import { hideEmail } from 'utils/user'
import { roleLabel } from 'utils/roleOptions'

export const ROLE_PRIORITY = {
  owner: 6,
  principal_accountable_person: 5,
  responsible_person: 4,
  principal_designer: 3,
  agent: 2,
  prospective_purchaser: 1
}

export const SAFETY_ROLE_KEYS = ['principal_accountable_person', 'responsible_person', 'principal_designer']

const buildings = count => `${count} building${count === 1 ? '' : 's'}`

export const skippedMessage = ({ skippedReasons = {}, heldRoles = [] } = {}) => {
  const parts = []
  if (skippedReasons.higherRole > 0) {
    const held = heldRoles.length ? heldRoles.join(' or ') : 'a higher role'
    parts.push(skippedReasons.higherRole === 1
      ? `This person is already the ${held} on that building, and a person can hold only one role per building. Name someone else, or record their organisation instead.`
      : `This person is already the ${held} on ${buildings(skippedReasons.higherRole)}, and a person can hold only one role per building.`)
  }
  if (skippedReasons.alreadyHolds > 0) parts.push(`They already hold this role on ${buildings(skippedReasons.alreadyHolds)}.`)
  if (skippedReasons.alreadySet > 0) parts.push(`${buildings(skippedReasons.alreadySet)} already ${skippedReasons.alreadySet === 1 ? 'has' : 'have'} this role set.`)
  if (skippedReasons.notApplicableState > 0) parts.push('This role was not marked as not applicable.')
  if (skippedReasons.noPermission > 0) parts.push(`You cannot manage people on ${buildings(skippedReasons.noPermission)}.`)
  return parts.join(' ')
}

export const peopleOptions = (candidates, roleKey, bpIds) => {
  const target = ROLE_PRIORITY[roleKey] || 0
  const targetName = roleLabel(roleKey)
  return candidates.map(c => {
    const name = c.name || hideEmail(c.email)
    const roles = c.roles || {}
    const blocked = bpIds.filter(id => roles[id] && (ROLE_PRIORITY[roles[id]] || 0) >= target)
    const eligible = bpIds.length - blocked.length
    let note
    if (bpIds.length === 1) {
      const current = roles[bpIds[0]]
      if (!current) note = 'Not on this building yet. Naming them gives them access.'
      else if (current === roleKey) note = `Already the ${targetName} here`
      else if (eligible === 0) note = `Already the ${roleLabel(current)} here. A person can hold one role per building.`
      else if (SAFETY_ROLE_KEYS.includes(current)) note = `Currently the ${roleLabel(current)} here. Naming them ${targetName} replaces that role.`
      else note = `Currently ${roleLabel(current)} on this building`
    } else if (eligible === 0) {
      note = 'Already holds this or a higher role on all of these buildings'
    } else if (eligible < bpIds.length) {
      note = `Can be named on ${eligible} of ${bpIds.length}. Already holds this or a higher role on the rest.`
    }
    return {
      value: c.id,
      label: name,
      sublabel: [c.name ? hideEmail(c.email) : null, note].filter(Boolean).join(' · ') || undefined,
      group: eligible > 0 ? 'People with access' : 'Cannot take this role',
      disabled: eligible === 0,
      eligible
    }
  }).sort((a, b) => (b.eligible > 0) - (a.eligible > 0))
}
